/* ---------------- Allowed Countries ---------------- */
export const ALLOWED_COUNTRIES = [
  "au",
  "br",
  "ca",
  "ch",
  "de",
  "dk",
  "es",
  "fi",
  "fr",
  "gb",
  "gr",
  "hk",
  "hu",
  "il",
  "in",
  "ie",
  "it",
  "jp",
  "mx",
  "pl",
  "pr",
  "pt",
  "se",
  "sg",
  "us",
  "za",
];
/* ------------------DEFAULT COUNTRY--------------------- */
export const DEFAULT_COUNTRY = "us";